const InboxIcon = ({ color = 'white', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.6673 8H10.6673L9.33398 10H6.66732L5.33398 8H1.33398"
				stroke={color}
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.63398 3.40797L1.33398 8.0013V12.0013C1.33398 12.3549 1.47446 12.6941 1.72451 12.9441C1.97456 13.1942 2.3137 13.3346 2.66732 13.3346H13.334C13.6876 13.3346 14.0267 13.1942 14.2768 12.9441C14.5268 12.6941 14.6673 12.3549 14.6673 12.0013V8.0013L12.3673 3.40797C12.2569 3.18583 12.0868 2.99888 11.876 2.86816C11.6651 2.73743 11.422 2.6681 11.174 2.66797H4.82732C4.57926 2.6681 4.33616 2.73743 4.12535 2.86816C3.91453 2.99888 3.74437 3.18583 3.63398 3.40797Z"
				stroke={color}
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default InboxIcon;

